export const meta = {
  id: 'C03',
  slug: 'jornada-formacao-treinamento',
  title: 'Jornada, Formação e Treinamento: qual a diferença?',
  description: 'Diferencie o papel de Jornada, Formação e Treinamento dentro do percurso de desenvolvimento no Personagrama.',
  profile: 'student',
  category: 'conceitos',
  type: 'concept',
  status: 'published',
  order: 200,
  keywords: ['jornada', 'formação', 'treinamento', 'curso', 'diferença', 'trilha', 'programa', 'percurso'],
  previous: 'C02',
  related: ['A05', 'A06', 'A09', 'O20'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Jornada, Formação e Treinamento: qual a diferença?

Os três recursos fazem parte do desenvolvimento, mas possuem funções diferentes.

<Diagram kind="journey-formation-training" />

## Treinamento

O **Treinamento** organiza aprendizagem em **Módulos → Aulas**.

Use essa ideia quando o foco principal for ensinar ou desenvolver conhecimento por meio de conteúdos e recursos de aprendizagem.

## Formação

A **Formação** é um programa estruturado de desenvolvimento organizado em **Etapas → Componentes**.

Ela pode reunir Treinamentos, atividades práticas, estudos de caso, role plays, aulas ao vivo, Mentorias, Evidências e checkpoints. Também pode utilizar regras como obrigatoriedade e pré-requisitos.

## Jornada

A **Jornada** organiza o caminho entre experiências e ajuda a mostrar onde a pessoa está e o que vem depois.

Ela pode conectar diferentes recursos do Personagrama em uma sequência coerente de desenvolvimento.

## Uma forma simples de lembrar

**Treinamento ensina.**  
**Formação estrutura um programa.**  
**Jornada organiza o caminho.**

<Callout type="concept">
  Jornada, Formação e Treinamento não competem entre si. Eles podem trabalhar juntos dentro do mesmo percurso de desenvolvimento.
</Callout>